import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import conversationReducer from './slices/conversationSlice';
import contactReducer from './slices/contactSlice';
import bookingReducer from './slices/bookingSlice';
import emailReducer from './slices/emailSlice';
import uiReducer from './slices/uiSlice';
import dashboardReducer from './slices/dashboardSlice';
import contactNavigationReducer from './slices/contactNavigationSlice';
import settingsTemplatesReducer from './slices/settingsTemplatesSlice';
import projectReducer from './slices/projectSlice';
import invoiceReducer from './slices/invoiceSlice';
import packageReducer from './slices/packageSlice';
import projectActivityReducer from './slices/projectActivitySlice';
import trainingDataReducer from './slices/trainingDataSlice';
import projectNavigationReducer from './slices/projectNavigationSlice';
import projectFormsReducer from './slices/projectFormsSlice';
import projectInvoicesReducer from './slices/projectInvoicesSlice';
import projectPortalReducer from './slices/projectPortalSlice';
import projectWorkflowReducer from './slices/projectWorkflowSlice';
import supportFeedbackReducer from './slices/supportFeedbackSlice';
import notificationReducer from './slices/notificationSlice';
import schedulerReducer from './slices/schedulerSlice';
import workflowTemplateReducer from './slices/workflowTemplateSlice';
import teamReducer from './slices/teamSlice';
import clientReducer from './slices/clientSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    conversations: conversationReducer,
    contacts: contactReducer,
    bookings: bookingReducer,
    email: emailReducer,
    ui: uiReducer,
    dashboard: dashboardReducer,
    contactNavigation: contactNavigationReducer,
    settingsTemplates: settingsTemplatesReducer,
    projects: projectReducer,
    invoices: invoiceReducer,
    packages: packageReducer,
    projectActivity: projectActivityReducer,
    trainingData: trainingDataReducer,
    projectNavigation: projectNavigationReducer,
    projectForms: projectFormsReducer,
    projectInvoices: projectInvoicesReducer,
    projectPortal: projectPortalReducer,
    projectWorkflow: projectWorkflowReducer,
    supportFeedback: supportFeedbackReducer,
    notifications: notificationReducer,
    scheduler: schedulerReducer,
    workflowTemplate: workflowTemplateReducer,
    team: teamReducer,
    clients: clientReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['auth/setUser'],
        // Ignore these field paths in all actions
        ignoredActionPaths: ['payload.timestamp'],
        // Ignore these paths in the state
        ignoredPaths: ['auth.user'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
